// frontend/src/components/common/FloatingCTA.js (versión simple)
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { X, Zap } from 'react-feather';
import '../assets/css/FloatingCTA.css';
import { ArrowUpCircle} from 'react-feather';
import Icon from '../components/Icon';


const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div
      className="floating-cta position-fixed bottom-0 end-0 m-4 shadow-lg rounded-3 bg-white"
      style={{
        maxWidth: '100%',
        zIndex: 9999,
        borderLeft: '4px solid #0d6efd',
        animation: 'slideIn 0.5s ease-out'
      }}
    >
      <button
        onClick={() => setIsVisible(false)}
        className="btn-close position-absolute top-0 end-0 m-2"
        style={{ fontSize: '12px' }}
      />

      <div className="floating-cta-body p-3">
        <div className="d-flex align-items-center mb-2">
          <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-2">
            <Zap size={18} className="text-primary" />
          </div>
          <strong className="medium">✨ LinksEasy</strong>
        </div>

        <p className="small text-muted mb-2">
          ¿Querés tener tu propia página de links como esta?
        </p>

        <Link to="/login" onClick={() => setIsVisible(false)}>
          <Button variant="primary" size="sm" className="w-100">
            Crear cuenta gratis <Icon name="users" size={12} color="#ffffff" />
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default FloatingCTA;